import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Motion";
import { EnquiryForm } from "../components/forms/EnquiryForm";
import { CONTACT } from "../components/site/Footer";

export default function Quote() {
  return (
    <main data-testid="quote-page">
      <PageHero overline="Enquiry & quote" lines={["Let's scope", "the work."]} testId="quote-hero" />
      <section className="bg-[var(--ink)] pb-28">
        <div className="mx-auto grid max-w-[1440px] gap-16 px-5 md:px-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="text-lg text-[var(--bone-2)]">
              Share a few details and our team will come back with a staffing plan or service proposal. The more you tell us about shifts, volumes and locations, the sharper the quote.
            </p>
            <dl className="mt-10 space-y-6 border-t border-white/10 pt-8">
              {[
                ["Phone", CONTACT.phone, `tel:${CONTACT.tel}`],
                ["Email", CONTACT.email, `mailto:${CONTACT.email}`],
                ["Head office", CONTACT.address.replace("Head Office: ", "")],
                ["Branch office", CONTACT.branch.replace("Branch Office: ", "")],
              ].map(([k, v, href]) => (
                <div key={k}>
                  <dt className="overline text-[var(--signal)]">{k}</dt>
                  <dd className="mt-1 break-words text-[var(--bone)]" data-testid={`quote-contact-${k.toLowerCase().replace(" ", "-")}`}>
                    {href ? <a href={href} className="hover:text-[var(--signal)]">{v}</a> : v}
                  </dd>
                </div>
              ))}
            </dl>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 lg:col-start-6">
            <EnquiryForm />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
